type LinkButtonData = {
  name: string;
  color: string;
};

export const linkButtons: LinkButtonData[] = [
  { name: "None", color: "#9CA3AF" },
  { name: "Watch Now", color: "#EF4444" },
  { name: "Send Message", color: "#3B82F6" },
  { name: "Join Channel", color: "#2563EB" },
  { name: "Learn More", color: "#64748B" },
  { name: "Open Facebook", color: "#3B82F6" },
  { name: "Open TikTok", color: "#000000" },
  { name: "Open Telegram", color: "#2563EB" },
  { name: "Download Now", color: "#EC4899" },
  { name: "Install Now", color: "#28A745" },
  { name: "Watch Live", color: "#EF4444" },
  { name: "Join Event", color: "#007BFF" },
  { name: "Apply Job", color: "#00695C" },
];

export class LinkButton {
  private constructor(public readonly value: string) {}

  static readonly none = new LinkButton("None");
  static readonly openShop = new LinkButton("Open Shop");
  static readonly openPage = new LinkButton("Open Page");
  static readonly installNow = new LinkButton("Install Now");

  static customStatus(linkButton: string): LinkButton {
    return new LinkButton(linkButton);
  }

  static getType(value: string): LinkButton {
    switch (value) {
      case "Open Shop":
        return LinkButton.openShop;
      case "Open Page":
        return LinkButton.openPage;
      case "Install Now":
        return LinkButton.installNow;
      default:
        return LinkButton.none;
    }
  }

  static getTextByType(value: string): string {
    switch (value) {
      case "Open Shop":
        return "FlipFlop Marketplace";
      case "Open Page":
        return "FlipFlop";
      case "Install Now":
        const userAgent = navigator.userAgent;
        if (/iPad|iPhone|iPod/.test(userAgent)) {
          return "IOS";
        } else if (/android/i.test(userAgent)) {
          return "Android";
        } else {
          return "IOS";
        }
      default:
        return value;
    }
  }

  static getColor(value: string): string {
    switch (value) {
      case "Open Shop":
        return "bg-slate-600";
      case "Open Page":
        return "bg-slate-600";
      case "None":
        return "bg-[#9CA3AF]";
      case "Watch Now":
        return "bg-[#EF4444]";
      case "Send Message":
        return "bg-[#3B82F6]";
      case "Join Channel":
        return "bg-[#2563EB]";
      case "Learn More":
        return "bg-[#64748B]";
      case "Open Facebook":
        return "bg-[#3B82F6]";
      case "Open TikTok":
        return "bg-[#000000]";
      case "Open Telegram":
        return "bg-[#2563EB]";
      case "Download Now":
        return "bg-[#EC4899]";
      case "Install Now":
        return "bg-[#28A745]";
      case "Watch Live":
        return "bg-[#EF4444]";
      case "Join Event":
        return "bg-[#007BFF]";
      case "Apply Job":
        return "bg-[#00695C]";
      default:
        return "bg-gray-400";
    }
  }
}

